import classNames from 'classnames';
import './index.scss';
export interface EcoSpaceSmallProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black' | 'white2';
    /**
     * 样式类
     */
    className?: string;
}

/**
 * 上下间隔
 */
export default function EcoSpaceSmall({ theme, className }: EcoSpaceSmallProps) {
    const prefixCls = 'eco-space-small';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });

    return <div className={compCls}></div>;
}
